import type { FileSystemNode } from '../../../../types/fileSystem.js';

const DRAG_PREFIX = 'kb-drag:';
const DROP_PREFIX = 'kb-drop:';

export const toDragId = (node: FileSystemNode) =>
  `${DRAG_PREFIX}${node.kind}:${node.id}`;

export const toDropId = (folderId: string) => `${DROP_PREFIX}${folderId}`;

export const fromDropId = (id: string | number | null | undefined) => {
  const value = `${id ?? ''}`;

  return value.startsWith(DROP_PREFIX) ? value.slice(DROP_PREFIX.length) : null;
};
